<script lang="ts">
  import { page } from '$app/stores';

  $: ({ layoutConfigStore } = $page.data);
  $: activeLayoutConfigName = layoutConfigStore?.activeLayoutConfigName;

  function handleSelect(e: Event) {
    const target = e.target as HTMLSelectElement;
    if (!layoutConfigStore) {
      // console.error('no layout config');
      return;
    }

    layoutConfigStore.setActiveLayoutConfig(target.value);
  }
</script>

<div>
  <label for="layouts" class="block text-sm font-medium leading-6 text-gray-900"
    >Layout</label
  >
  <select
    on:change={handleSelect}
    id="layouts"
    name="layouts"
    class="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
  >
    {#each $layoutConfigStore ?? [] as layoutConfig}
      {#if layoutConfig.name !== 'Default Win' && layoutConfig.name !== 'Default Place'}
        <option
          value={layoutConfig.name}
          selected={layoutConfig.name === $activeLayoutConfigName}
          >{layoutConfig.name}</option
        >
      {/if}
    {/each}
  </select>
</div>
